import { AttentionModal } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Prompt, useHistory } from 'react-router-dom';

export function RouteLeavingGuard(props) {
  const { headerText, navigationBlocked = false, warningText } = props;

  // HOOKS
  // React
  const [modalVisible, setModalVisible] = useState(false);
  const [navigationConfirmed, setNavigationConfirmed] = useState(false);
  const [lastLocation, setLastLocation] = useState();
  // Router
  const history = useHistory();

  /**
   * Handles page refresh or manual URL change with in-built browser popup.
   * Note: Only when user interacted with page.
   */
  const onBeforeUnload = (event) => {
    event.preventDefault();

    /* eslint-disable-next-line no-param-reassign */
    event.returnValue = '';
  };

  useEffect(() => {
    if (navigationBlocked) {
      window.addEventListener('beforeunload', onBeforeUnload);
    } else {
      window.removeEventListener('beforeunload', onBeforeUnload);
    }

    return () => window.removeEventListener('beforeunload', onBeforeUnload);
  }, [navigationBlocked]);

  useEffect(() => {
    if (navigationConfirmed && lastLocation) {
      history.push(lastLocation.pathname);
    }
  }, [navigationConfirmed, lastLocation]);

  // TODO: not called when using Link component outside of FormsModule - investigate
  const handleBlockedNavigation = (nextLocation) => {
    if (!navigationConfirmed && navigationBlocked) {
      setModalVisible(true);
      setLastLocation(nextLocation);

      return false;
    }

    return true;
  };

  const onDismiss = () => {
    setModalVisible(false);
  };

  const onConfirm = () => {
    setModalVisible(false);
    setNavigationConfirmed(true);
  };

  return (
    <>
      <Prompt message={handleBlockedNavigation} when={navigationBlocked} />
      <AttentionModal
        onClose={onDismiss}
        onConfirm={onConfirm}
        text={warningText}
        title={headerText}
        visible={modalVisible}
      />
    </>
  );
}

RouteLeavingGuard.propTypes = {
  headerText: PropTypes.string.isRequired,
  navigationBlocked: PropTypes.bool,
  warningText: PropTypes.string.isRequired,
};

export default RouteLeavingGuard;
